module.exports = __webpack_public_path__ + "img/horizontal_4_2_3.96db2936.png";